<script setup>
import { mainColors, SwSvgIcon } from '@getswish/design-library-web';

defineProps(['variant']);

const variantToLabel = {
  apiReference: 'API Reference',
  documentation: 'Documentation',
};

const variantToClass = {
  apiReference: 'api-reference',
  documentation: 'documentation',
};
const variantToColor = {
  apiReference: mainColors.interactionColorSecondary,
  documentation: mainColors.interactionColorQuaternary,
};
</script>

<template>
  <button type="button" class="button" :class="variantToClass[variant]">
    <div class="label">
      {{ variantToLabel[variant] }}
    </div>

    <SwSvgIcon
      class="icon"
      :name="variant === 'apiReference' ? 'code' : 'document'"
      :width="16"
      :color="variantToColor[variant]"
    />
  </button>
</template>

<style lang="scss" scoped>
.button {
  @include button-label-small;
  border-radius: $border-radius-xx-small;
  border: none;
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 2.1875rem;
  padding: 0 12px;

  .icon {
    margin-left: 8px;
  }

  &:focus-visible {
    @include swish-focus-outline;
  }

  &.api-reference {
    background-color: $background-color-secondary;
    &:hover {
      background-color: $nav-button-light-hover;
    }
    .label {
      color: $interaction-color-secondary;
    }
  }

  &.documentation {
    background-color: $interaction-color-secondary;
    &:hover {
      background-color: $nav-button-dark-hover;
    }
    .label {
      color: $interaction-color-quaternary;
    }
  }
}
</style>
